import React, { useEffect, useState } from 'react';
import api from '../api/client';

export default function Watchlist() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api
      .get('/api/watchlist')
      .then((res) => setItems(res.data))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  };

  useEffect(load, []);

  const remove = async (id) => {
    await api.delete(`/api/watchlist/${id}`);
    setItems((prev) => prev.filter((i) => i.id !== id));
  };

  return (
    <div className="mp-watchlist">
      <header className="mp-page-header">
        <h2>Your Watchlist</h2>
      </header>

      {loading && <div className="mp-deck-msg">Loading…</div>}

      {!loading && items.length === 0 && (
        <div className="mp-empty-note">
          Nothing here yet. Swipe right on a card to add it.
        </div>
      )}

      <ul className="mp-watch-list">
        {items.map((item) => (
          <li className="mp-watch-item" key={item.id}>
            {item.poster_url ? (
              <img
                className="mp-watch-poster"
                src={item.poster_url}
                alt=""
                onError={(e) => {
                  e.currentTarget.style.visibility = 'hidden';
                }}
              />
            ) : (
              <div className="mp-watch-poster mp-watch-poster--blank" />
            )}
            <div className="mp-watch-info">
              <div className="mp-watch-title">{item.title}</div>
              <div className="mp-watch-sub">
                {item.media_type === 'show' ? 'TV Show' : 'Movie'}
                {item.year ? ` · ${item.year}` : ''}
              </div>
              <div className="mp-watch-actions">
                {item.plex_url && (
                  <a
                    className="mp-watch-link"
                    href={item.plex_url}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Open in Plex
                  </a>
                )}
                <button className="mp-watch-remove" onClick={() => remove(item.id)}>
                  Remove
                </button>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
